import React from "react";
import { useTranslation } from "react-i18next";
import StyledText from "../../util/StyledText";

const OpenQuestionMarkerForm = ({
  question,
  answer,
  noCorrectAnswer,
  neutralMessage,
  handleNoCorrectAnswerToggle,
  handleNeutralMessageChange,
  successMessage,
  errorMessage,
  handleQuestionChange,
  handleAnswerChange,
  handleSuccessMessageChange,
  handleErrorMessageChange,
  index,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <label className="mt-4">{t("questionQuiz")}</label>
      <StyledText
        testId="question-field"
        markerText={question}
        setMarkerText={(value) => handleQuestionChange(value, index)}
        index={index}
      />
      <label className="mt-4">{t("quizAnswer")}</label>
      <StyledText
        testId="answer-field"
        markerText={answer}
        setMarkerText={(value) => handleAnswerChange(value, index)}
        index={index}
        disabled={noCorrectAnswer}
      />
      <div className="mt-3">
        <input
          type="checkbox"
          checked={noCorrectAnswer}
          onChange={() => handleNoCorrectAnswerToggle(index)}
        />
        <label className="ms-2">{t("noCorrectAnswer")}</label>
      </div>

      {noCorrectAnswer ? (
        <>
          <label className="mt-4">{t("neutralMessage")}</label>
          <StyledText
            testId="neutral-field"
            key={`neutral-${index}`}
            markerText={neutralMessage}
            setMarkerText={(value) => handleNeutralMessageChange(value, index)}
            index={index}
          />
        </>
      ) : (
        <>
          <label className="mt-4">{t("successMessageQuiz")}</label>
          <StyledText
            testId="success-field"
            key={`success-${index}`}
            markerText={successMessage}
            setMarkerText={(value) => handleSuccessMessageChange(value, index)}
            index={index}
          />
          <label className="mt-4">{t("errorMessageQuiz")}</label>
          <StyledText
            testId="error-field"
            key={`error-${index}`}
            markerText={errorMessage}
            setMarkerText={(value) => handleErrorMessageChange(value, index)}
            index={index}
          />
        </>
      )}
    </>
  );
};

export default OpenQuestionMarkerForm;
